export default class DigitalJobsEvents {
  constructor(params) {
    this.params = params;
  }

  index() {
    if (this.params.role !== "area_director") {
      $(".js-open-history-filter").sideNav({ edge: "left" });
      N2.handle("click", ".js-close-history-filter", () => {
        $(".js-open-search-filter").sideNav("hide");
      });
    }

    if ($(".js-filter-checkbox:checked").length > 0) {
      $(".js-clear-all").removeClass("hidden");
    }
  }
}
